module.exports = __webpack_public_path__ + "img/icon_briefcase.ba7db191.svg";